import * as React from "react";

export default function BatteryIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect
        x="0.333008"
        y="0.746216"
        width="48.0001"
        height="48"
        rx="7.92"
        fill="#F5E7E2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.3322 31.9462H15.9322C14.6062 31.9462 13.5322 30.8722 13.5322 29.5462V19.9461C13.5322 18.6201 14.6062 17.5461 15.9322 17.5461H30.3322C31.6582 17.5461 32.7322 18.6201 32.7322 19.9461V29.5462C32.7322 30.8722 31.6582 31.9462 30.3322 31.9462Z"
        stroke="#C6795E"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4927 28.3462L25.2927 24.7462H20.9727L22.7727 21.1462"
        stroke="#C6795E"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7324 21.1462H33.9492C34.1352 21.1462 34.3188 21.1894 34.4856 21.2734L35.0688 21.565C35.4756 21.7678 35.7324 22.1842 35.7324 22.6378V26.8546C35.7324 27.3094 35.4756 27.7246 35.0688 27.9274L34.4856 28.219C34.3188 28.303 34.1352 28.3462 33.9492 28.3462H32.7324"
        stroke="#C6795E"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
